import axios from "axios";
import { header, getLanguage } from "./header";

const assistent = header('restapi/api/v1/ai/echo');

const getAuth = () =>{
    let authorization = localStorage.getItem('auth')
    assistent.defaults.headers.common['Authorization'] =`Bearer ${authorization}` 
}

const setLanguage = () => {
    assistent.defaults.headers.common['Accept-Language'] = getLanguage()
}

export const AssistentService = {

    getUserSessionsList(userId, companyId, limit) {
        setLanguage();
        getAuth();

        return assistent.get('sessions', {
            params: {
                company_id: companyId,
                user_id: userId,
                limit
            }
        }).then(response => response.data);
    },

    async generateSessionTitle(sessionId, userId, companyId, targetLanguage){
        setLanguage();
        getAuth();

        return await assistent.post(`sessions/${sessionId}/title?user_id=${userId}&company_id=${companyId}`, {user_id: userId, company_id: companyId, target_language: targetLanguage}).then(response => response.data);
    },

    getUserSession(sessionId, userId, companyId, limit){
        setLanguage();
        getAuth();
        return assistent.get(`sessions/${sessionId}`, {
            params: {
                company_id: companyId,
                user_id: userId,
                limit
            }
        })
            .then(response => response.data);
    },

    getUsageStatistics(from_date, to_date, limit, user_id, company_id) {
        setLanguage();
        getAuth();

        return assistent.get('stats', {
            params: {
                from_date,
                to_date,
                limit,
                user_id,
                company_id
            }
        }).then(response => response.data);
    },

/*async chatWithAssistent(payload, { onChunk, onDone, onError } = {}) {
    setLanguage();

    const authorization = localStorage.getItem('auth');

    const baseURL = assistent.defaults.baseURL;

    const response = await fetch(`${baseURL}/chat`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authorization}`,
            'Accept': 'text/event-stream',
        },
        body: JSON.stringify({
            ...payload,
            stream: true,
        }),
    });
    
    if (!response.ok) {
        let error;

        try {
            error = await response.json();
        } catch {
            error = { message: 'Request failed' };
        }

        onError?.(error);
        return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    
    while (true) {
        const { done, value } = await reader.read();

        if (done) {
            onDone?.();
            break;
        }

        const chunk = decoder.decode(value, { stream: true });

        const lines = chunk
            .split('\n')
            .filter(line => line.startsWith('data:'));

        for (const line of lines) {
            const data = line.replace('data:', '').trim();

            if (data === '[DONE]') {
                onDone?.();
                return;
            }

            try {
                const parsed = JSON.parse(data);
                onChunk?.(parsed);
            } catch {
                onChunk?.(data);
            }
        }
    }
},*/

    async chatWithAssistent(payload, { onChunk, onDone, onError } = {}) {
        setLanguage();
        getAuth();

        return assistent.post('chat', payload)
            .then(response => {
                onChunk?.(response.data);
                onDone?.();
                return response.data;
            })
    },

    getHealth() {
        setLanguage();
        getAuth();
        return assistent.get('health').then(response => response.data);
    },

    getModels() {
        setLanguage();
        getAuth();
        return assistent.get('models').then(response => response.data);
    },

}